export const ROLES = {
  ADMINISTRATOR: 'ADMINISTRATOR',
  SUPER_ADMIN: 'SUPER_ADMIN',
  CLINICIAN: 'CLINICIAN',
};

export const ROUTES = {
  PATIENTS: {
    INDEX: 'patients',
    VIEW_PATIENTS: 'view',
    REQUIRE_REVIEW_TAB: 'require-review',
    ALL_PATIENTS_TAB: 'all-patients',
    NO_DATA_TAB: 'no-data',
    PATIENT_DETAILS_TAB: 'details',
    PATIENT_JOURNEY_TAB: 'journey',
    HEALTH_DATA_TAB: 'health-data',
    PATIENT_FILES_TAB: 'files',
    PATIENT_ACTIVITY_LOG_TAB: 'activity-log',
    CARE_TEAM_EDIT: 'care-team',
    ADD: 'new',
    CREATE_REFERRAL: 'create-referral',
    PARAMS: {
      PATIENT_ID: ':patientId',
    },
  },
  ACTIVITY_LOG: {
    INDEX: 'activity-log',
    VIEW_LOGS: 'view',
    ALL_UPDATES_TAB: 'all-updates',
    CLINICIAN_UPDATES_TAB: 'clinician-updates',
    PATIENT_UPDATES_TAB: 'patient-updates',
  },
  PATIENT_ENROLLMENT_EMR: {
    INDEX: 'patient-enrollment-emr',
    ARCHIVED_TAB: 'archived',
    OPEN_TAB: 'open',
  },
  ADMIN_DASHBOARD: 'admin-dashboard',
  ADMIN_LANDING: 'admin-landing',
  CLINICIAN_LANDING: 'clinician-landing',
  ABOUT: 'about',
  LOGOUT: 'logout',
  NOT_FOUND: 'not-found',
};

export const NO_DATA = 'No Data';
export const NO_DATA_DASH = '-';
export const NOT_AVAILABLE = 'N/A';
export const PLACEHOLDER = null;
export const POSTAL_CODE_MAX_LENGTH = 5;
export const PHONE_NUMBER_MAX_LENGTH = 14;
